<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">

        <mat-icon class="logo-icon mr-16" *fuseIfOnDom>supervised_user_circle</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom>{{'main.personnel' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"
        fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

      </div>
      <!-- / SEARCH -->


      <div>

        <button mat-button class="mat-icon-button sidenav-toggle mr-12"
          fuseMatSidenavToggler="user-main-sidenav"
          fxHide.gt-lg>
          <mat-icon>filter_list</mat-icon>
        </button>
      </div>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT CARD -->
    <mat-sidenav-container class="my-sidenav" style="position: absolute;
    width: 210px;
    height: calc(100vh - 210px);
    right: 0;
    z-index: 999;
    top: 136px;
    background: transparent;">
      <mat-sidenav #sidenav class="sidenav mat-sidenav-opened" position="end" opened="true" mode="side"
        fuseMatSidenavHelper="user-main-sidenav" mat-is-locked-open="gt-sm"
                   [ngClass]="{'hide-menu': !sidenav.opened}" style="    position: absolute;
    width: 100%;
    margin: 0px;
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    overflow: hidden;
    transform: none;
    visibility: visible;">
        <filter-menu [filters]="filterData" [page]="'budget'" [filterFromDB]="userFilters"
        (chooseFilter)="chooseFilters($event)"></filter-menu>
      </mat-sidenav>
    </mat-sidenav-container>

    <div class="content-card mat-white-bg"
      [ngClass]="{'margin-big-screen': sidenav.opened}">
      @for (personal of dataSource; track personal) {
        <div>
          <mat-accordion class="column has-text-centered">
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title style="max-width: none !important;">
                  <div [style.color]="!personal.events || (personal.events && !personal.events.length) ? 'grey' : 'black'"
                    class="total">{{personal.name}} ({{'hourly_rate' | translate}} {{currency}}
                    {{personal.preparation ? personal.preparation : personal.rate}}.-)
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (personal.events) {
                <table mat-table [dataSource]="personal.events" class="products-table">
                  <ng-container matColumnDef="date">
                    <th mat-header-cell *matHeaderCellDef style="width: 30%"> {{'event-preview.date' | translate}}</th>
                    <td mat-cell *matCellDef="let element" style="overflow: scroll; white-space: nowrap;">{{element.date}}</td>
                  </ng-container>
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef style="width: 35%">{{'event_name' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.title}}h</td>
                  </ng-container>
                  <ng-container matColumnDef="preparation">
                    <th mat-header-cell *matHeaderCellDef> {{'Preparation' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.preparation}}h</td>
                  </ng-container>
                  <ng-container matColumnDef="execution">
                    <th mat-header-cell *matHeaderCellDef> {{'Execution' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.execution}}h</td>
                  </ng-container>
                  <ng-container matColumnDef="followUp">
                    <th mat-header-cell *matHeaderCellDef> {{'postprocessing' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{element.followUp}}h</td>
                  </ng-container>
                  <ng-container matColumnDef="total">
                    <th mat-header-cell *matHeaderCellDef> {{'Total' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{+element.followUp + +element.execution +
                      +element.preparation}}h
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div class="total">
                  <div>{{'Expenditure_Hours' | translate}}</div>
                  <div>{{personal.totalHours}}h</div>
                </div>
                <div class="total">
                  <div>{{'personnel_costs' | translate}}</div>
                  <div>{{currency}} {{personal.totalRates}}.-</div>
                </div>
              }
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      }
      @if (!dataSource && !noData) {
        <div class="choose-org">
          {{'pls_choose_org' | translate}}
        </div>
      }
      @if (!dataSource && noData) {
        <div class="choose-org">
          {{'no_data' | translate}}
        </div>
      }
      <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
  </div>
</div>


